<div class="subscriptions-container">
  <div class="container-fluid">
    <div class="row g-6 mb-6"></div>
    <div class="table-container">
      <div class="subscription-title">
        <h5>Abonamente</h5>
      </div>
      <div
        class="filters-wrapper"
        #filtersWrapper
        [class.embedded]="filtersReady"
        [class.hidden-before-attach]="!filtersReady"
      >
        <form [formGroup]="form" class="filters-container">
          <div class="filter-item date-filter">
            <mat-form-field appearance="outline">
              <mat-label>Enter a date range</mat-label>
              <mat-date-range-input
                [rangePicker]="picker"
                formGroupName="dateRange"
              >
                <input matStartDate formControlName="start" placeholder="Start date" />
                <input matEndDate formControlName="end" placeholder="End date" />
              </mat-date-range-input>

              <button
                mat-icon-button
                matSuffix
                type="button"
                class="clear-button"
                *ngIf="isDateRangeSelected()"
                (click)="clearDateRange()"
              >
                <i class="bi bi-x"></i>
              </button>

              <mat-datepicker-toggle
                matIconSuffix
                [for]="picker"
                *ngIf="!isDateRangeSelected()"
              ></mat-datepicker-toggle>

              <mat-date-range-picker #picker></mat-date-range-picker>

              <mat-error
                *ngIf="form.get('dateRange.start')?.hasError('matStartDateInvalid')"
              >Invalid start date</mat-error>
              <mat-error
                *ngIf="form.get('dateRange.end')?.hasError('matEndDateInvalid')"
              >Invalid end date</mat-error>
            </mat-form-field>
          </div>

          <div class="filter-item identification-filter">
            <mat-form-field appearance="outline">
              <mat-label>Tip identificare</mat-label>
              <mat-select formControlName="offstreetIdentificationType">
                <mat-option value="">Toate tipurile</mat-option>
                <mat-option
                  *ngFor="let option of offstreetIdentificationTypeOptions"
                  [value]="option.value"
                >
                  [{{ option.value }}]
                  <ng-container *ngIf="option.label">
                    - {{ option.label }}
                  </ng-container>
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </form>
      </div>

      <div class="table-responsive">
        <table
          datatable
          [dtOptions]="dtOptions"
          class="table table-hover table-nowrap"
          id="subscriptionsDataTable"
        >
          <thead class="thead-light">
            <tr>
              <th scope="col" (click)="sortTable('firstName')">Nume</th>
              <th scope="col" (click)="sortTable('lastName')">Prenume</th>
              <th scope="col" (click)="sortTable('email')">E-mail</th>
              <th scope="col" (click)="sortTable('licensePlate')">
                Număr de înmatriculare
              </th>
              <th scope="col" (click)="sortTable('type')">Tip</th>
              <th scope="col" (click)="sortTable('description')">
                Denumire abonament
              </th>
              <th scope="col" (click)="sortTable('location')">Locație</th>
              <th scope="col" (click)="sortTable('cardNumber')">Număr card</th>
              <th scope="col" (click)="sortTable('offstreetIdentificationType')">
                Tip identificare
              </th>
              <th scope="col" (click)="sortTable('status')">Status</th>
              <th scope="col" (click)="sortTable('startDate')">
                Data de început
              </th>
              <th scope="col" (click)="sortTable('endDate')">
                Data de sfârșit
              </th>

              <th scope="col" (click)="sortTable('offstreetConsumer')"></th>
            </tr>
          </thead>
        </table>
      </div>
    </div>
  </div>
</div>